interface BorderRadius {
  sm: string
  md: string
  fullyRounded: string
  l: string
  xl: string
}

const radius: BorderRadius = {
  sm: '4px',
  md: '8px',
  fullyRounded: '50%',
  l: '20px',
  xl: '12px',
}

export default radius
